import { useEffect, useRef } from 'react';
export var usePrevious = function (value, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    var ref = useRef(defaultValue);
    useEffect(function () {
        ref.current = value;
    });
    return ref.current;
};
